/* unplugin-vue-components disabled */import script from "./analyse2.vue?vue&type=script&setup=true&lang=js"
export * from "./analyse2.vue?vue&type=script&setup=true&lang=js"

import "./analyse2.vue?vue&type=style&index=0&id=3c608a9e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c608a9e"]])

export default __exports__